import axios from 'axios';
import { ADMIN_API_BASE, adminAuthConfig } from './api_admin';

const _err = (e) => { if (e.response) console.error('Admin payouts error:', e.response.status, e.response.data); };
const qs = (p) => {
    const s = new URLSearchParams();
    Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.append(k, v); });
    return s.toString();
};

export const APIAdminPayouts = async (token, params = {}) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/payouts/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

export const APIAdminPayoutDetail = async (token, id) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/payouts/${id}/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

// Расшифрованные реквизиты (finance/superadmin, пишется в аудит)
export const APIAdminPayoutRequisites = async (token, id) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/payouts/${id}/requisites/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

export const APIAdminPayoutInProgress = async (token, id) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/payouts/${id}/mark-in-progress/`, {}, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

export const APIAdminPayoutMarkPaid = async (token, id, comment = '') => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/payouts/${id}/mark-paid/`, { comment }, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

export const APIAdminPayoutReject = async (token, id, comment) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/payouts/${id}/reject/`, { comment }, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};